import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {of} from 'rxjs';
import {map, switchMap, tap} from 'rxjs/operators';
import {V3School} from "../../model/v3/schools";
import {SchoolV3RestService} from "../../services/rest/v3/school-rest.service";

@Component({
    selector: 'top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent implements OnInit {
  school: V3School;
  @Input() title: String;
  constructor(
    private route: ActivatedRoute,
    private schoolV3Rest: SchoolV3RestService
  ) {}

  ngOnInit(): void {
    this.route.parent.paramMap
      .pipe(
        map((params) => Number(params.get('schoolId'))),
        switchMap((schoolId) =>
          schoolId ? this.loadSchool(schoolId) : of(null)
        )
      )
      .subscribe();
  }

  loadSchool(schoolId: number) {
    return this.schoolV3Rest
      .getSchool(schoolId)
      .pipe(tap((school) => (this.school = school)));
  }

  getTitle() {
    return this.title;
  }
}
